import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_4 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_5 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " PROPERTY PRICE", -1)
const _hoisted_7 = { class: "tw-px-4" }
const _hoisted_8 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_9 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE", -1)
const _hoisted_11 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_12 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT", -1)
const _hoisted_14 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_15 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT", -1)
const _hoisted_17 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_18 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE", -1)
const _hoisted_20 = { class: "tw-px-4" }
const _hoisted_21 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_22 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_24 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_25 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " YEARS", -1)
const _hoisted_27 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_28 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_30 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_31 = { class: "tw-flex justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-justify-center" }
const _hoisted_32 = { class: "tw-flex tw-justify-center" }
const _hoisted_33 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_34 = { class: "tw-flex tw-justify-end" }
const _hoisted_35 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL ESTIMATED MONTHLY PAYMENT $ ", -1)
const _hoisted_37 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import axios from 'axios';
import { ref, computed } from 'vue';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";

//COMPONENTS
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";

import { useToast } from "@/composables/useToast";
import SheetMorgage from '../economicSheet/SheetMorgage.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MortgagePayment',
  setup(__props) {

const toast = useToast();

//VARIABLES
const url = environment.URL_API;
const loading = ref(false);
const userSession = ref(null)
const selectedMLO = ref(null)
const selectedCompanyTitle = ref({ data: null })
const selectedInspector = ref({ data: null })
const customer = ref({
  name: '',
  phone: '',
  email: ''
})
const scenarioValid = ref(false)
const financialInformation = ref({
  pmi: 0,
  mortgage: 0,
  propertyPrice: 0,
  monthlyBudget: 0,
  downPayment: 0,
  propertyPriceQuantity: 0,
  monthlyPayment: 0,
  propertyTaxes: 0,
  stateTaxes: 0,
  propertyInsurance: 0,
  association: 0,
  totalMonthly: 0,
  sortOut: 0
})

const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
}
getSession();

// GET TAXES FROM REALTOR FORM
const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    if (response.data.averageTaxesAndInsurance) {
      financialInformation.value.propertyTaxes = response.data.averageTaxesAndInsurance.property_taxes
      financialInformation.value.stateTaxes = response.data.averageTaxesAndInsurance.federal_taxes
      financialInformation.value.propertyInsurance = response.data.averageTaxesAndInsurance.property_insurance
    }
  }
  loading.value = false;
};
getRealtorForm();

const pmi = computed(() => {
  let result = 0
  if (selectedMLO.value !== null) {
    const percentage = financialInformation.value.downPayment / financialInformation.value.propertyPrice
    const percentageTwo = parseFloat(percentage.toFixed(2))
    if (percentageTwo < (selectedMLO.value.minimumDownPayment / 100)) {
      result = ((selectedMLO.value.PMI / 100) * loanAmount.value) / 12
    }
  }
  return result !== 0 ? parseFloat((result).toFixed(0)) : result
})

const sortOutRatio = computed(() => {
  let interest_rate = 0;
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
  }
  return Math.pow(1 + ((interest_rate / 12) / 100), years) * ((interest_rate / 12) / 100);
})

const sortOutRatio2 = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    result = Math.pow(1 + (interest_rate / 12) / 100, years) - 1
  }
  return result
})

const sortOutFactor = computed(() => {
  let result = 0
  if (sortOutRatio.value !== 0 && sortOutRatio2.value !== 0) {
    result = sortOutRatio.value / sortOutRatio2.value
  }
  return result
})

const loanAmount = computed(() => {
  let result = financialInformation.value.propertyPrice - financialInformation.value.downPayment
  return parseFloat(result.toFixed(2))
})

const propertyTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const federalTaxes = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.stateTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const propertyInsurance = computed(() => {
  let result = 0
  if (financialInformation.value.propertyPrice !== 0) {
    result = (financialInformation.value.propertyPrice * financialInformation.value.propertyInsurance / 12) / 100
  }
  return parseFloat(result.toFixed(2))
})

const monthlyPayment = computed(() => {
  let interest_rate = 0;
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null) {
    interest_rate = parseFloat(selectedMLO.value.interestRate)
    const interestRateRatio = (interest_rate / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest
  }
  return parseFloat(result.toFixed(2))
})

const totalMonthly = computed(() => {
  let result = 0
  if (financialInformation.value.association !== null) {
    result = monthlyPayment.value + propertyTaxes.value + federalTaxes.value + propertyInsurance.value + financialInformation.value.association
  }
  return parseFloat(result.toFixed(2))
})


const submitFormula = async () => {
  financialInformation.value.totalMonthly = parseFloat((monthlyPayment.value + pmi.value).toFixed(2))
}

const getData = async () => {
  loading.value = true;
}

const submitScenario = async () => {
  loading.value = true;
  const response = await axios(`${url}realtor-mortgage`, {
    method: "POST",
    data: {
      realtorMortgagePayment: [{
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "MORTGAGE PAYMENT",
        propertyPrice: financialInformation.value.propertyPrice,
        downPayment: financialInformation.value.downPayment,
        loanAmount: loanAmount.value,
        interestRate: selectedMLO.value.interestRate,
        years: selectedMLO.value.filters.year,
        pmi: pmi.value,
        totalMonthly: financialInformation.value.totalMonthly,
        client_name: customer.value.name,
        client_email: customer.value.email
      }],
      customer: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "MORTGAGE PAYMENT",
        name: customer.value.name,
        phone: customer.value.phone,
        email: customer.value.email
      },
      mloSelected: {
        ID: null,
        user_id: userSession.value.iduser,
        scenario_type: "MORTGAGE PAYMENT",
        name: selectedMLO.value.realtorMLOData.name,
        lastname: selectedMLO.value.realtorMLOData.lastname,
        phone: selectedMLO.value.realtorMLOData.phone,
        email: selectedMLO.value.realtorMLOData.email,
        program: selectedMLO.value.filters.program,
        interestRate: selectedMLO.value.interestRate,
        minimumDownPayment: selectedMLO.value.minimumDownPayment,
        pmi: selectedMLO.value.PMI,
        backEndRatio: selectedMLO.value.backEndRatio,
        maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
        client_name: customer.value.name,
        client_email: customer.value.email
      },

    }

  });

  if (!response.data.error) {
    loading.value = false;
    getData()
    await toast.success(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  } else {
    loading.value = false;
    await toast.error(response.data.message, {
      position: "top-end",
      timer: 3000,
      showCloseButton: true,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''MORTGAGE PAYMENT''",
      helpVideo: "https://www.realtortools.org/media/VideoMortgagePayment.mp4"
    }),
    _createElementVNode("div", null, [
      _createVNode(ResidentialView, { header: false })
    ]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(SheetMorgage),
      _createVNode(FindA, {
        userSession: userSession.value,
        usingCompanyTitle: selectedCompanyTitle.value,
        usingInspector: selectedInspector.value
      }, null, 8, ["userSession", "usingCompanyTitle", "usingInspector"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(MLO, {
          title: "MORTGAGE PAYMENT",
          userSession: userSession.value,
          usingMLO: selectedMLO.value,
          "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
          customer: customer.value
        }, null, 8, ["userSession", "usingMLO", "customer"]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPrice",
                      value: financialInformation.value.propertyPrice,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((financialInformation.value.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("td", _hoisted_14, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "downPayment",
                      value: financialInformation.value.downPayment,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((financialInformation.value.downPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("td", _hoisted_17, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "loanAmount",
                      value: loanAmount.value,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((loanAmount).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", _hoisted_21, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("td", _hoisted_24, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.interestRate : '') + " % ", 1)
                ]),
                _createElementVNode("tr", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, _toDisplayString(selectedMLO.value !== null ? selectedMLO.value.filters.year : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, " $ " + _toDisplayString(pmi.value), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (submitFormula())),
            class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl disabled:tw-bg-[#cfcfcf] disabled:tw-text-white"
          }, "DONE")
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyPrice",
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                  disabled: "",
                  value: financialInformation.value.totalMonthly,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((financialInformation.value.totalMonthly) = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("button", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (submitScenario())),
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, " SAVE & REGISTER ")
        ])
      ])
    ])
  ]))
}
}

})